import React from "react";
import PropTypes from "prop-types";

import InfoPanel from "containers/home/InfoPanel/InfoPanel";
import WorkList from "containers/home/WorkList/WorkList";
import ListDragDropPicker from "components/ListDragDropPicker";
import commonStyles from "css/common.module.css";
import widgetStyles from "css/widgets.module.css";
import flexStyles from "css/flex.module.css";
// import OfficeSelection from "components/OfficeSelection";

class Home extends React.Component {
  componentDidMount() {
    this.props.fetchData();
  }

  render() {
    const {
      fetchData,
      columnOptions,
      isColumnPickerVisible,
      toggleColumnPicker,
      onColumnClick,
      onColumnOrderChange,
      columnConfig,
      userOffice,
      setUserOffice,
      loadingWorkItems,
      workItemError,
      currentWorkList,
      ...rest
    } = this.props;
    // if (!userOffice.current && userOffice.options.length > 1) {
    //   return (
    //     <div className={`${flexStyles.flex} ${commonStyles.page}`}>
    //       <OfficeSelection
    //         offices={userOffice.options}
    //         onOfficeChange={setUserOffice}
    //       />
    //     </div>
    //   );
    // }

    return (
      <div className={`${flexStyles.flex} ${commonStyles.page}`}>
        <InfoPanel
          className={`${widgetStyles.base} ${widgetStyles.first_column}`}
        />
        <WorkList
          {...rest}
          fetchData={fetchData}
          error={workItemError}
          loading={loadingWorkItems}
          columnConfig={columnConfig}
          toggleColumnPicker={toggleColumnPicker}
        />
        <ListDragDropPicker
          title="Customize columns"
          description="Select the data you want to be displayed (down to 3) and the columns ordering"
          float="right"
          currentWorkList={currentWorkList}
          isOpen={isColumnPickerVisible}
          options={columnOptions}
          onClose={toggleColumnPicker}
          onItemClick={onColumnClick}
          onOrderChange={onColumnOrderChange}
        />
      </div>
    );
  }
}

Home.propTypes = {
  fetchData: PropTypes.func
};

Home.defaultProps = {
  fetchData: () => {}
};

export default Home;
